module.exports = __webpack_public_path__ + "img/monitorEquipment_uncheck.21f814cd.png";